import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-162924d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-items-center tw-inline-flex" }
const _hoisted_2 = {
  key: 0,
  class: "tw-mr-[3px]"
}

import store from "@/store";
import {
  checklistRequestedStatusId,
  checklistStatusId,
  statusCode,
} from "@/utils/constants";
import utilities from "@/utils/utilities";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'vendorStatusBadge',
  props: {
  value: { type: String, required: true },
  isCursorPointer: { type: Boolean, default: false, required: false },
  statusNumber: { type: Number, default: () => 0 },
  label: { type: String, default: () => null },
  lableClass: { type: String, default: () => "" },
  isCheckPlan: { type: Boolean, default: false },
  classCurrentUser: { type: String, default: "" },
},
  emits: ["update:status"],
  setup(__props, { emit }) {

const props = __props;


const color = computed(() => (props.isCheckPlan ? "#904bd6" : "#878787"));
const borderColor = computed(() => (props.isCheckPlan ? "#eee4f9" : "#eff0f1"));
const defaultUiText = computed(() => store.state.LanguagePicker.defaultUiText);
const languageSelectedText = computed(
  () => store.state.LanguagePicker.languageSelectedText,
);


const updateStatus = (value) =>
  value == statusCode.pending ||
  (checklistStatusId.created && emit("update:status", value));
const getUiText = (id: string, isArray = false) => {
  return utilities.getUiText(
    id,
    languageSelectedText.value,
    defaultUiText.value,
    isArray,
  );
};

const status = {};

status[checklistRequestedStatusId.created] = {
  label: getUiText(
    "app-component-assessments-checklists-requested-status-created-1",
  ),
  className: "created",
};
status[checklistStatusId.inProgress] = {
  label: getUiText(
    "app-component-assessments-checklist-requested-status-inprogress-1",
  ),
  className: "inProgress",
};
status[checklistStatusId.waiting] = {
  label: getUiText(
    "app-component-vendor-input-checklist-requested-status-waiting-1",
  ),
  className: "inProgress",
};
status[checklistStatusId.submitted] = {
  label: getUiText(
    "app-component-status-badge-vendor-assessment-submitted-status-1",
  ),
  className: "submitted",
};
status[checklistStatusId.completed] = {
  label: getUiText(
    "app-component-assessments-checklists-requested-status-completed-1",
  ),
  className: "complete",
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(`${
      __props.isCursorPointer ? 'tw-w-[180px] tw-cursor-pointer' : 'tw-w-[180px]'
    }`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      (__props.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass([`${status[__props.value]?.className} ${__props.classCurrentUser}`, "cell-status tw-flex tw-items-center"]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (updateStatus(__props.value)))
          }, [
            (__props.statusNumber)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(props.statusNumber), 1))
              : _createCommentVNode("", true),
            _createElementVNode("span", {
              class: _normalizeClass(`tw-max-w-[115px] tw-truncate ${__props.lableClass}`),
              "data-cy": "vendor-checklist-requested-status"
            }, _toDisplayString(__props.label ?? status[__props.value]?.label), 3)
          ], 2))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})